import React from 'react';
import genStyles from '../generale.module.css';

export default function ConfirmSaveForm({ onClose, onValidate }) {
    

    return (
        <div className="row">
            <p className="center-align font_size_22">
                Attention, vous n'avez pas enregistré les modifications que vous avez apportées. 
            </p>
            <div className={genStyles.modalActions}>
                <button
                className={`${genStyles.modalBtn} ${genStyles.modalBtnSecondary}`}
                onClick={onClose}
                >
                Quitter sans enregistrer
                </button>
                <button
                className={`${genStyles.modalBtn} ${genStyles.modalBtnPrimary}`}
                onClick={onValidate}
                >
                Enregistrer et quitter
                </button>
            </div>
        </div>
    );
}
